import React from "react";
import "./testimonials.css";
import { data } from "./data";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination, Autoplay } from "swiper/modules";
import { FaStar, FaRegStar, FaStarHalfAlt } from "react-icons/fa";

const Testimonials = () => {
  return (
    <section className="testimonials section">
      <h2 className="section__title">Testimonials</h2>
      <span className="section__subtitle">Client Feedback</span>

      <Swiper
        className="testimonials_container container"
        centeredSlides={true}
        loop={true}
        slidesPerView={1}
        spaceBetween={20}
        pagination={false} 
        autoplay={{
          delay: 4000,
          disableOnInteraction: false,
        }}
        breakpoints={{
          640: { slidesPerView: 1 },
          768: { slidesPerView: 1 },
          1024: { slidesPerView: 1 },
        }}
        modules={[Pagination, Autoplay]}
      >
        {data.map(({ id, image, name, rating }) => (
          <SwiperSlide className="testimonials_card" key={id}>
            <div className="testimonial_image_container">
              <img
                src={image}
                alt={`Feedback from ${name}`}
                className="testimonial_image"
              />
            </div>

            <div className="testimonial_info">
              <h3 className="testimonials_title">{name}</h3>
              <div className="stars_container">
                {[...Array(5)].map((_, i) => {
                  if (i + 1 <= rating) return <FaStar key={i} className="star full" />;
                  if (i + 0.5 === rating) return <FaStarHalfAlt key={i} className="star half" />;
                  return <FaRegStar key={i} className="star empty" />;
                })}
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
};

export default Testimonials;










// import React from "react";
// import "./testimonials.css";
// import { data } from "./data";
// // Import Swiper React components
// import { Swiper, SwiperSlide } from "swiper/react";

// // Import Swiper styles
// import "swiper/css";
// import "swiper/css/pagination";
// import { Pagination, Autoplay } from "swiper/modules";

// const Testimonials = () => {
//   return (
//     <section className="testimonials section">
//       <h2 className="section__title">Testimonial</h2>
//       <span className="section__subtitle">What i offer</span>

//       <Swiper
//         className="testimonials_container container"
//         content="centered"
//         loop={true}
//         slidesPerView={1}
//         spaceBetween={10}
//         pagination={{ clickable: true }} // اظهار نقاط العناصر
//         autoplay={{
//           delay: 5000, // تأخير الحركة (بالمللي ثانية)
//           disableOnInteraction: false, // استمرار الحركة بعد تفاعل المستخدم
//         }}
//         breakpoints={{
//           640: {
//             slidesPerView: 1,
//             spaceBetween: 10,
//           },
//           768: {
//             slidesPerView: 1,
//             spaceBetween: 60,
//           },
//           1024: {
//             slidesPerView: 1,
//             spaceBetween: 60,
//           },
//         }}
//         modules={[Pagination, Autoplay]}
//       >
//         {data.map(({ image, name, description, id }) => (
//           <SwiperSlide className="testimonials_card" key={id}>
//             <div className="imgName_container">
//               <img
//                 src={image}
//                 alt="testimonial Pic"
//                 className="testimonials_img"
//               />
//               <h3 className="testimonials_title">{name}</h3>
//             </div>
//             <p className="testimonials_description" style={{ marginBottom: "2rem"}}>{description}</p>
//           </SwiperSlide>
//         ))}
//       </Swiper>
//     </section>
//   );
// };

// export default Testimonials;
